var PaymentFlowPresenter = /** @class */ (function () {
    function PaymentFlowPresenter(usecase) {
        this.usecase = usecase;
    }
    PaymentFlowPresenter.prototype.tradePayment = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.tradePayment.execute({
                onSuccess: function (data) { return resolve(data); },
                onError: function (error) { return reject(error); },
            }, req);
        });
    };
    PaymentFlowPresenter.prototype.paymentGateway = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.paymentGateway.execute({
                onSuccess: function (data) { return resolve(data.data); },
                onError: function (error) { return reject(error); },
            }, req);
        });
    };
    PaymentFlowPresenter.prototype.getPayBankDetails = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.getPayBankDetails.execute({
                onSuccess: function (data) { return resolve(data.data); },
                onError: function (error) { return reject(error); },
            }, null);
        });
    };
    PaymentFlowPresenter.prototype.getMfPaymentStatus = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.getmfPaymentStatus.execute({
                onSuccess: function (data) { return resolve(data); },
                onError: function (error) { return reject(error); },
            }, req);
        });
    };
    return PaymentFlowPresenter;
}());
export default PaymentFlowPresenter;
